import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-credit-repair',
  templateUrl: './credit-repair.component.html',
  styleUrls: ['./credit-repair.component.scss']
})
export class CreditRepairComponent implements OnInit {

  constructor() { }
  
  ngOnInit(): void {
  }

}
